import {UNIT_OF_WEIGHT} from '@mybake/ui/common/dictionary';

type IngredientAmount = {
    quantity?: number | null;
    weight?: number | null;
    unitOfWeight?: string;
    proportions?: Array<{
        proportion?: number | null;
        quantity?: number | null;
        weight?: number | null;
    }>;
};

export const getIngredientAmount = (ingredient: IngredientAmount, selectedProportion: number | string) => {
    const multiplier = Number(selectedProportion);
    const base = ingredient.proportions?.find(item => Number(item.proportion) === 1);
    const quantity = ingredient.quantity ?? base?.quantity ?? 0;
    const weight = ingredient.weight ?? base?.weight ?? null;

    return {
        quantity: Number(quantity) * multiplier,
        weight: weight == null ? null : Number(weight) * multiplier,
    };
};

export const formatDecimal = (value: number) => new Intl.NumberFormat(undefined, {maximumFractionDigits: 2}).format(value);

export const formatIngredientAmount = (ingredient: IngredientAmount, selectedProportion: number | string) => {
    const {quantity} = getIngredientAmount(ingredient, selectedProportion);
    const formattedQuantity = formatDecimal(Number(quantity));
    return `${formattedQuantity} ${ingredient.unitOfWeight ?? ''}`.trim();
};

export const getIngredientsTotalWeight = (ingredients: IngredientAmount[], selectedProportion: number | string) => ingredients.reduce((total, ingredient) => {
    const amount = getIngredientAmount(ingredient, selectedProportion);

    if (ingredient.unitOfWeight === UNIT_OF_WEIGHT.PCS) return total + Number(amount.weight ?? 0);
    if (ingredient.unitOfWeight === UNIT_OF_WEIGHT.G) return total + Number(amount.quantity ?? 0);
    return total;
}, 0);
